import FutureExplorersEditor from '@/components/FutureExplorersEditor';

export default function AdminFutureExplorers() {
  return (
    <div className="container mx-auto px-4 py-8">
      <FutureExplorersEditor showTitle />
    </div>
  );
}
